import React, { Component } from 'react';
import { TouchableOpacity, StyleSheet, View, Text, Image } from 'react-native';
import images from "../../images/ImagesControl";
import { Table, TableWrapper } from '../../components/Table';
import Cell from '../../components/Cell';
import { Content1, Content2, Content3 } from './Content';

class Appendix2 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cateWidthArr: [150, 150],
            cateTableData1: [["Pineapple", "Strawberries"], ["Pineapple", "Strawberries"]],
            cateTableData2: [["Apple", "Banana"], ["Apple", "Banana"]],
            proList1: ["Pineapple", "Strawberries", "Kiwis", "Mangoes"],
            proList2: ["Apple", "Banana", "Peach", "Orange"],
            proDetail: {
                Pineapple: {
                    id: '1',
                    code: "Pineapple",
                    desc: "Pineapple",
                    price: "Price: HK$10",
                    qty: '10',
                    image: images.pineapple,
                    response: '{"code":"Pineapple","desc":"Imported Pineapple","iRev":2,"id":1 ...}',
                    inventory: 'Available'
                },
                Strawberries: {
                    id: '2',
                    code: "Strawberries",
                    desc: "Strawberries",
                    price: "Price: HK$2",
                    qty: '-2',
                    image: images.strawberries,
                    response: '{"code":"Strawberries","desc":"Imported Strawberries","iRev":2,"id":2 ...}',
                    inventory: 'Sold Out'
                },
                Kiwis: {
                    id: '3',
                    code: "Kiwis",
                    desc: "Kiwis",
                    price: "Price: HK$5",
                    qty: '20',
                    image: images.kiwis,
                    response: '{"code":"Kiwis","desc":"Imported Kiwis","iRev":2,"id":3 ...}',
                    inventory: 'Available'
                },
                Mangoes: {
                    id: '4',
                    code: "Mangoes",
                    desc: "Mangoes",
                    price: "Price: HK$7",
                    qty: '-5',
                    image: images.mangoes,
                    response: '{"code":"Mangoes","desc":"Imported Mangoes","iRev":2,"id":4 ...}',
                    inventory: 'Sold Out'
                },
                Apple: {
                    id: '5',
                    code: "Apple",
                    desc: "Apple",
                    price: "Price: HK$9",
                    qty: '15',
                    image: images.apple,
                    response: '{"code":"Apple","desc":"Local Apple","iRev":2,"id":5 ...}',
                    inventory: 'Available'
                },
                Banana: {
                    id: '6',
                    code: "Banana",
                    desc: "Banana",
                    price: "Price: HK$11",
                    qty: '5',
                    image: images.banana,
                    response: '{"code":"Banana","desc":"Local Banana","iRev":2,"id":6 ...}',
                    inventory: 'Available'
                },
                Peach: {
                    id: '7',
                    code: "Peach",
                    desc: "Peach",
                    price: "Price: HK$15",
                    qty: '16',
                    image: images.peach,
                    response: '{"code":"Peach","desc":"Local Peach","iRev":2,"id":7 ...}',
                    inventory: 'Available'
                },
                Orange: {
                    id: '8',
                    code: "Orange",
                    desc: "Local Orange",
                    price: "Price: HK$20",
                    qty: '-3',
                    image: images.orange,
                    response: '{"code":"Orange","desc":"Local Orange","iRev":2,"id":8 ...}',
                    inventory: 'Sold Out'
                }
            },
            proSeriesId: { "IMPORT": "1", "LOCAL": "2" },
            proSeries: 'IMPORT',
            proResponse: '',
            request: 'Pineapple, Strawberries',
            requestArray: ['Pineapple', 'Strawberries'],
        }
    };

    _onRefreshData(proSeries) {
        var newData = this.state.cateTableData1;

        if (proSeries === 'IMPORT') {
            newData = this.state.cateTableData1;
            newData[0][0] = this.state.proList1[Math.floor(Math.random() * this.state.proList1.length)];
            newData[0][1] = this.state.proList1[Math.floor(Math.random() * this.state.proList1.length)];
            newData[1][0] = this.state.proList1[Math.floor(Math.random() * this.state.proList1.length)];
            newData[1][1] = this.state.proList1[Math.floor(Math.random() * this.state.proList1.length)];
        } else {
            newData = this.state.cateTableData2;
            newData[0][0] = this.state.proList2[Math.floor(Math.random() * this.state.proList2.length)];
            newData[0][1] = this.state.proList2[Math.floor(Math.random() * this.state.proList2.length)];
            newData[1][0] = this.state.proList2[Math.floor(Math.random() * this.state.proList2.length)];
            newData[1][1] = this.state.proList2[Math.floor(Math.random() * this.state.proList2.length)];
        }

        var requestArray = [];
        for (let i = 0; i < newData.length; i++) {
            var code1 = newData[i][0];
            var code2 = newData[i][1];

            if (!requestArray.includes(code1)) {
                requestArray.push(code1);
            }
            if (!requestArray.includes(code2)) {
                requestArray.push(code2);
            }
        }

        var request = "";
        var code = "";
        for (let i = 0; i < requestArray.length; i++) {
            code = requestArray[i];

            if (request !== "") {
                request += ", ";
            }
            request += code;
        }

        if (proSeries === 'IMPORT') {
            this.setState({
                proSeries: proSeries,
                cateTableData1: newData,
                request: request,
                requestArray: requestArray,
            });
        } else {
            this.setState({
                proSeries: proSeries,
                cateTableData2: newData,
                request: request,
                requestArray: requestArray,
            });
        }
    }

    render() {
        const state = this.state;

        const proElement = (data) => (
            <View style={[{ justifyContent: 'center', alignItems: 'center' }]}>
                <Image source={state.proDetail[data].image}
                    style={[{ height: 100, width: 100 }]} />
                <Text>{state.proDetail[data].desc}</Text>
                <Text>{state.proDetail[data].price}</Text>
                <Text style={
                    (state.proDetail[data].inventory === "Sold Out") ? { color: 'red' } : { color: 'green' }
                }>
                    {state.proDetail[data].inventory}
                </Text>
            </View>
        );

        const requestElement = (data, index) => (
            <Text>
                {'GET http://[server]/jsf/rfws/erp/trdg/stock/viewLocLvl/1/'}
                <Text style={{ color: 'brown', fontWeight: 'bold' }}>
                    {state.proDetail[data].id}
                </Text>
            </Text>
        );

        const responseElement = (data, index) => (
            <Text>
                {
                    '{'
                    + '\n       "size": 1,'
                    + '\n       "values": ['
                    + '\n               "basicUnitId": 52,'
                }
                <Text style={
                    (state.proDetail[data].inventory === "Sold Out") ? { color: 'red', fontWeight: 'bold' } : { color: 'green', fontWeight: 'bold' }
                }>
                    {
                        '\n               "basicQty": ' + state.proDetail[data].qty + ','
                    }
                </Text>
                {
                    '\n               "basicCode": "RTUNIT",'
                    + '\n               "locCode": "L0001-A",'
                    + '\n               "lotno": "RT01_OPENINGS",'
                    + '\n               "basicCode": "RTUNIT",'
                }
                <Text style={[{ color: 'brown', fontWeight: 'bold' }]}>
                    {'\n               "proId": ' + state.proDetail[data].id + ','}
                </Text>
                {
                    '\n               "qty": ' + state.proDetail[data].qty + ','
                    + '\n               "unitCode": "RTUNIT",'
                    + '\n               "unitId": 3791,'
                    + '\n               "lotnoLot": "A",'
                    + '\n               "locType": 31,'
                    + '\n               "locId": 40.0,'
                    + '\n               "lotNoId": 1681.0'
                    + '\n       ],'
                    + '\n}'
                }
            </Text>
        );

        return (
            <View style={styles.container}>

                <Content1 />

                <View style={styles.catalogContainer}>
                    <View style={styles.catalogContent}>
                        <Image source={images.logo} style={styles.catalogLogoImage} />
                        <Text style={styles.catalogLogoTitle}>
                            {"ABC Fruit Catalog"}
                        </Text>
                    </View>
                    <View style={styles.catalogContent}>
                        <View style={{ paddingRight: 20 }}>
                            <Text style={{ paddingTop: 20, fontWeight: 'bold' }}>
                                {"Imported Product List"}
                            </Text>
                            <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                                {state.cateTableData1.map((rowData, index) => (
                                    <TableWrapper key={index} style={[{ flexDirection: 'row', overflow: 'hidden' }]}>
                                        {rowData.map((cellData, cellIndex) => (
                                            <Cell key={cellIndex}
                                                data={proElement(cellData)}
                                                textStyle={styles.text}
                                                width={state.cateWidthArr[cellIndex]} />
                                        ))}
                                    </TableWrapper>
                                ))}
                            </Table>
                        </View>
                        <View>
                            <Text style={{ paddingTop: 20, fontWeight: 'bold' }}>
                                {"Local Product List"}
                            </Text>
                            <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                                {state.cateTableData2.map((rowData, index) => (
                                    <TableWrapper key={index} style={[{ flexDirection: 'row', overflow: 'hidden' }]}>
                                        {rowData.map((cellData, cellIndex) => (
                                            <Cell key={cellIndex}
                                                data={proElement(cellData)}
                                                textStyle={styles.text}
                                                width={state.cateWidthArr[cellIndex]} />
                                        ))}
                                    </TableWrapper>
                                ))}
                            </Table>
                        </View>
                    </View>
                </View>

                <Content2 />

                <Content3 />

                <View style={[styles.catalogContainer, { height: 500 }]}>
                    <View style={styles.catalogContent}>
                        <Image source={images.logo} style={styles.catalogLogoImage} />
                        <Text style={styles.catalogLogoTitle}>
                            {"ABC Fruit Catalog"}
                        </Text>
                    </View>
                    <View style={styles.catalogContent}>
                        <View style={{ paddingRight: 20 }}>
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ paddingTop: 20, fontWeight: 'bold' }}>
                                    {"Imported Product List"}
                                </Text>
                            </View>
                            <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                                {state.cateTableData1.map((rowData, index) => (
                                    <TableWrapper key={index} style={{ flexDirection: 'row', overflow: 'hidden' }}>
                                        {rowData.map((cellData, cellIndex) => (
                                            <Cell key={cellIndex}
                                                data={proElement(cellData)}
                                                textStyle={styles.text}
                                                width={state.cateWidthArr[cellIndex]} />
                                        ))}
                                    </TableWrapper>
                                ))}
                            </Table>
                            <TouchableOpacity onPress={() => this._onRefreshData("IMPORT")}>
                                <View style={styles.submitBtn}>
                                    <Text style={styles.submitBtnText}>Refresh Imported Fruits</Text>
                                </View>
                            </TouchableOpacity>
                        </View>
                        <View>
                            <View style={{ flexDirection: 'row' }}>
                                <Text style={{ paddingTop: 20, fontWeight: 'bold' }}>
                                    {"Local Product List"}
                                </Text>
                            </View>
                            <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                                {state.cateTableData2.map((rowData, index) => (
                                    <TableWrapper key={index} style={{ flexDirection: 'row', overflow: 'hidden' }}>
                                        {rowData.map((cellData, cellIndex) => (
                                            <Cell key={cellIndex}
                                                data={proElement(cellData)}
                                                textStyle={styles.text}
                                                width={state.cateWidthArr[cellIndex]} />
                                        ))}
                                    </TableWrapper>
                                ))}
                            </Table>
                            <TouchableOpacity onPress={() => this._onRefreshData("LOCAL")}>
                                <View style={styles.submitBtn}>
                                    <Text style={styles.submitBtnText}>Refresh Local Fruits</Text>
                                </View>
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>

                <Text style={[styles.subheading, { paddingBottom: 20, width: 1000 }]}>
                    {'Sample request to check Inventory Level '}
                    <Text style={{ color: 'brown' }}>
                        {state.request}
                    </Text>
                </Text>
                <View style={styles.border}>
                    <Text style={[styles.text, { paddingLeft: 80, paddingBottom: 20 }]}>
                        {state.requestArray.map((rowData, index) => (
                            <View key={index}>
                                {
                                    requestElement(rowData, index)
                                }
                            </View>
                        ))}
                    </Text>
                </View>

                <Text style={[styles.subheading, { paddingBottom: 20 }]}>
                    {"Sample Response"}
                </Text>
                <View style={styles.border}>
                    <View style={{ paddingLeft: 80, paddingTop: 20, paddingBottom: 20 }}>
                        {state.requestArray.map((rowData, index) => (
                            <View key={index}>
                                {
                                    responseElement(rowData, index)
                                }
                            </View>
                        ))}
                    </View>
                </View>

            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        width: 700,
    },
    catalogContainer: {
        flexDirection: 'column',
        borderWidth: 1,
        borderStyle: 'dashed',
        borderRadius: 20,
        justifyContent: 'center',
        alignItems: 'center',
        height: 460,
    },
    catalogContent: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    catalogLogoTitle: {
        fontSize: 25,
        fontWeight: 'bold',
        paddingLeft: 20,
        fontStyle: 'iTalic'
    },
    catalogLogoImage: {
        height: 60,
        width: 180
    },
    refreshImage: {
        height: 20,
        width: 20,
        resizeMode: 'contain'
    },
    tableBorder: {
        borderWidth: 2,
        borderColor: '#c8e1ff'
    },
    subheading: {
        paddingTop: 20,
        fontSize: 20,
        fontWeight: 'bold',
    },
    text: {
        paddingTop: 20,
    },
    hyperlink: {
        fontStyle: 'iTalic',
        color: 'blue',
        textDecorationLine: 'underline',
    },
    tableText: {
        margin: 6,
        fontSize: 10
    },
    submitContainer: {
        paddingTop: 50
    },
    submitBtn: {
        height: 40,
        //borderWidth: 1,
        backgroundColor: '#c8e1ff',
        //borderColor: '#c8e1ff',
        //borderRadius: 15,
        justifyContent: 'center',
        alignItems: 'center',
    },
    submitBtnText: {
        fontSize: 15,
        textAlign: 'center',
    },
    border: {
        borderWidth: 1,
    },
    requestContent: {
        height: 500,
        padding: 20,
    },
    responseContent: {
        height: 500,
        padding: 20,
    },
    faqContainer: {
        paddingBottom: 20,
    },
    head: {
        height: 40,
        backgroundColor: '#f1f8ff',
    },
    textInput: {
        margin: 6,
        backgroundColor: 'transparent',
        fontSize: 10
    },
    delBtn: {
        width: 20,
        height: 18,
        backgroundColor: '#c8e1ff',
        borderRadius: 2,
        alignSelf: 'center',
    },
    delBtnText: {
        textAlign: 'center',
        color: '#fff'
    },
    row: {
        flexDirection: 'row',
        overflow: 'hidden',
    },
});

export default Appendix2;



// WEBPACK FOOTER //
// ./src/pages/ap2/Appendix2.js